export const navLinks = [
  {
    id: 1,
    title: "Home",
    path: "/",
  },
  {
    id: 2,
    title: "About Us",
    path: "/about-us",
  },
  {
    id: 3,
    title: "Our Products",
    path: "/our-products",
  },
  {
    id: 4,
    title: "Contact Us",
    path: "/contact-us",
  },
];
